<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md4 offset-md4>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoVacio :titulo="titulo" />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    ref="controlFoco"
                    label="Usuario*"
                    v-model="itemActivo.Nombre"
                    v-mask="'##-########-#'"
                    :rules="[rules.requerido]"
                    @keyup.enter="ejecutarAccion('Login')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    label="Clave*"
                    v-model="itemActivo.Clave"
                    :rules="[rules.requerido, rules.minimo4, rules.maximo50]"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    hint="Al menos 4 caracteres"
                    counter
                    @click:append="show1 = !show1"
                    @keyup.enter="ejecutarAccion('Login')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="text-right">
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        rounded
                        class="ma-1"
                        @click="ejecutarAccion('Inicializar')"
                        v-on="on"
                      >
                        Cancelar
                        <v-icon right>clear</v-icon>
                      </v-btn>
                    </template>
                    <span>Volver al comienzo</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        rounded
                        color="primary"
                        class="ma-1"
                        @click="ejecutarAccion('Login')"
                        v-on="on"
                      >
                        Iniciar
                        <v-icon right>lock_open</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir una nueva sesión</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <ModalLoginOTP
      :activo="modalLoginOTPActivo"
      :subtitulo="modalLoginOTPSubtitulo"
      :expectedOTP="itemActivo.OTP"
      @ejecutarAccion="ejecutarAccion"
    />
    <ModalLoginLicencia
      :activo="modalLoginLicenciaActivo"
      :subtitulo="modalLoginLicenciaSubtitulo"
      :expectedOTP="itemActivo.Habilitacion"
      @ejecutarAccion="ejecutarAccion"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { AUTH_REQUEST } from "@/store/store";
import { AUTH_LOGOUT } from "@/store/store";
import EncabezadoVacio from "@/components/EncabezadoVacio";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import ModalLoginOTP from "@/components/ModalLoginOTP";
import ModalLoginLicencia from "@/components/ModalLoginLicencia";
export default {
  name: "Login",
  components: {
    EncabezadoVacio,
    PieCrud,
    Mensaje,
    ModalLoginOTP,
    ModalLoginLicencia
  },
  data() {
    return {
      titulo: this.$appNombre,
      itemVacio: {
        Nombre: "",
        Clave: "",
        OTP: "",
        Licencia: "",
        Habilitacion: "",
        ValidacionOTP: true
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        minimo4: v => (!!v && v.length >= 4) || "Mínimo 4 caracteres",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres"
      },
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: "",
      loading: false,
      show1: false,
      modalLoginOTPActivo: false,
      modalLoginOTPSubtitulo: "",
      modalLoginLicenciaActivo: false,
      modalLoginLicenciaSubtitulo: ""
    };
  },
  mounted() {
    this.ejecutarAccion("Inicializar");
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Login":
          if (this.$refs.form.validate()) this.login();
          break;
        case "AceptarLoginLicencia":
          this.aceptarLoginLicencia();
          break;
        case "CerrarLoginLicencia":
          this.modalLoginLicenciaActivo = false;
          this.logout();
          break;
        case "AceptarLoginOTP":
          this.aceptarLoginOTP();
          break;
        case "CerrarLoginOTP":
          this.modalLoginOTPActivo = false;
          this.logout();
          break;
        case "CancelarAviso":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.$refs.form.resetValidation();
          this.$refs.controlFoco.focus();
          this.loading = false;
          break;
      }
    },
    login: function() {
      this.loading = true;
      const { Nombre, Clave } = this.itemActivo;
      this.$store.dispatch(AUTH_REQUEST, { Nombre, Clave })
        .then(resp => {
          if (resp.data.Resultado == "OK") {
            this.itemActivo.ValidacionOTP = resp.data.ValidacionOTP;
            this.itemActivo.Licencia = resp.data.Licencia;
            this.modalLoginLicenciaSubtitulo = "#" + resp.data.Licencia;
            this.itemActivo.Habilitacion = resp.data.Habilitacion;
            this.modalLoginOTPSubtitulo = resp.data.Telefono;
            if(resp.data.Ejecuciones < 1)
              this.modalLoginLicenciaActivo = true;
            else {
              if (this.itemActivo.ValidacionOTP) {
                this.itemActivo.OTP = resp.data.OTP;
                console.warn(">>> OTP " + this.itemActivo.OTP);
                this.modalLoginOTPActivo = true;
              }
              else
                this.aceptarLoginOTP();
              this.loading = false;
            }
          }
          else
            this.mostrarMensaje(true, "Aviso", null, resp.data.Resultado);
        })
        .catch(() => {
          this.mostrarMensaje(true, "Error", null, "Acceso Denegado. Puede solicitar una habilitación enviando un mail a soporte@ekogroup.com.ar con su nombre de usuario.");
        });
    },
    aceptarLoginLicencia: function() {
      this.loading = true;
      this.modalLoginLicenciaActivo = false;
      HttpHelper.post("Sistema/GuardarEjecucion", this.itemActivo)
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });      
      this.logout();
    },
    aceptarLoginOTP: function() {
      // this.$router.go(-1);
      this.$router.push("/home");
    },
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
